module.exports = __webpack_public_path__ + "img/lnmidia.8236eed7.png";